import {
	type BeautifulMentionComponentProps,
	type BeautifulMentionsTheme,
	useBeautifulMentions,
} from 'lexical-beautiful-mentions'
import { type Ref } from 'react'
import MentionUser from '../MentionUser'
import styles from './LexicalMentionNode.module.css'

export const userMentionsTheme: BeautifulMentionsTheme = {
	'@': styles.mentionUser,
	'@Focused': styles.focused,
}
export type LexicalMentionNodeData = {
	avatar: string
	screenName: string
}
export interface LexicalMentionNodeProps extends BeautifulMentionComponentProps<LexicalMentionNodeData> {
	ref?: Ref<HTMLDivElement>
}

export default function LexicalMentionNode({
	trigger,
	value,
	data,
	children,
	ref,
	...props
}: LexicalMentionNodeProps) {
	const { removeMentions } = useBeautifulMentions()

	if (!data) {
		return null
	}

	return (
		<MentionUser
			ref={ref}
			className={styles.mentionUser}
			onClick={() =>
				void removeMentions({
					trigger: '@',
					value,
				})
			}
			data={data}
		/>
	)
}
